'use client';

import { X } from 'lucide-react';
import IconAdaptive from '@/components/IconAdaptive';

export interface HubNewsSelectedTagUnitProps {
    label: string;
    onRemove: () => void;
}

export default function HubNewsSelectedTagUnit({ label, onRemove }: HubNewsSelectedTagUnitProps) {
    return (
        <button
            type="button"
            className="inline-flex items-center gap-1.5 h-7 px-2.5 rounded-lg border border-gray-700 bg-color-base text-color-white-base whitespace-nowrap font-corp font-medium text-[12px] cursor-pointer hover:brightness-125 transition-all duration-150"
            onClick={onRemove}
            aria-label={`${label} の条件を外す`}
        >
            {label}
            <IconAdaptive Icon={X} strokeWidth={2.2} baseSize={14} breakpoints={{ md: 14 }} />
        </button>
    );
}
